<template>
  <div class="users">
    <EntityList
      v-bind:endpoint="'api/users'"
      v-bind:filters="'?roles=ROLE_SUPER_ADMIN'"
      v-bind:entity="userEntity"
      v-bind:editAllowedFields="['email', 'password']"
      v-bind:notDisplayedFields="['id', 'password']"
      v-bind:addLinkToDetails="false"
      v-bind:defaultValues="{ roles:  this.$store.state.userPermissions.superuser}"
      v-bind:title="'Superusers'"
      v-bind:enableSearch="true"
      v-bind:searchFields="[{ text: 'Email', value: 'email' }]"/>
  </div>
</template>

<script>
import EntityList from './EntityList/EntityList.vue';
import UserEntity from '../store/entity/User';

export default {
  name: 'superusers',
  components: { EntityList },
  data() {
    return {
      userEntity: UserEntity,
    };
  },
};
</script>

<style scoped>

</style>
